import { render } from "./ChangePassword.vue?vue&type=template&id=8f14c4ec&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=8f14c4ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f14c4ec"],['__file',"src/core/main/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f14c4ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f14c4ec', __exports__)) {
    console.log('reload')
    api.reload('8f14c4ec', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue?vue&type=template&id=8f14c4ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('8f14c4ec', render)
  })

}


export default __exports__